import { CATERING_PT_BR } from "#pages/org/catering/translations/catering-pt-br";
import { categories } from "./categories";
import { chartOfAccounts } from "./chart-of-accounts";
import { clientArea } from "./client-area/";
import { clients } from "./clients";
import { communication } from "./communication/";
import { employees } from "./employees/";
import { fiscalBoard } from "./fiscal-board";
import { fiscalCouvertForm } from "./fiscal-couvert-form";
import { fiscalData } from "./fiscal-data";
import { fiscalGroupForm } from "./fiscal-group-form";
import { minimmConsummation } from "./fiscal-minimum-consummation-form";
import { fiscalProfileForm } from "./fiscal-profile-form";
import { fiscalRecharge } from "./fiscal-recharge-form";
import { fiscalSettings } from "./fiscal-settings";
import { giftCard } from "./gift-card";
import { giftback } from "./giftback";
import { helpers } from "./helpers";
import { internalSalesCampaign } from "./internal-sales-campaign";
import { vendors_PT_BR } from "#pages/org/vendors/translations";
import { integrations } from "./integrations";
import { loyalty } from "./loyalty";
import { messagesAnalytics } from "./messages-analytics";
import { productFeatureTemplates } from "./product-feature-templates";
import { ORG_PRODUCTS_PT_BR } from "./products";
import { reports } from "./reports";
import { satisfactionSurvey } from "./satisfaction-survey";
import { teamAndRoles } from "./team-and-roles";
import { zendeskHistory } from "./zendesk-history";

export const orgPT = {
	employees,
	fiscalBoard,
	fiscalData,
	fiscalProfileForm,
	fiscalCouvertForm,
	fiscalGroupForm,
	fiscalSettings,
	helpers,
	loyalty,
	clients,
	productFeatureTemplates,
	communication,
	products: ORG_PRODUCTS_PT_BR,
	clientArea,
	reports,
	satisfactionSurvey,
	chartOfAccounts,
	minimmConsummation,
	teamAndRoles,
	vendors: vendors_PT_BR,
	fiscalRecharge,
	giftback,
	giftCard,
	internalSalesCampaign,
	integrations,
	categories,
	messagesAnalytics,
	zendeskHistory,
	catering: CATERING_PT_BR,
};
